import { Component, OnInit, OnChanges, Output, isDevMode } from '@angular/core';
import { OauthTokenData } from 'oauth-lib/lib/token-data.model';
import { map } from 'rxjs/internal/operators/map';
import { tap } from 'rxjs/internal/operators/tap';
import { APP_CONFIG } from 'src/app/config';
import { CommunicationService } from '../services/communication-service/communication.service';
import { SecurityService } from '../services/security-service/security.service';
import { UserStorageService } from '../services/user-storage-service/user-storage.service';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  private APP_CONFIG: any;
  private navbarHeight: number;
  private footerHeight: number;
  public sidenavMobile: boolean;
  public sidenavOpened: boolean;
  public sidenavLocked: boolean;

  constructor() {
    this.APP_CONFIG = APP_CONFIG;
    this.navbarHeight = this.APP_CONFIG.navbarHeight;
    this.footerHeight = this.APP_CONFIG.footerHeight;
    this.onResizeMobileWidth();
  }

  ngOnInit() {
  }


  public onResizeMobileWidth() {
    if ((window.innerWidth < this.APP_CONFIG.responsiveWidth)) {
      this.sidenavMobile = true;
      this.sidenavOpened = false;
      this.sidenavLocked = true;
    } else {
      this.sidenavMobile = false;
      this.sidenavOpened = true;
      this.sidenavLocked = true;
    }
  }

  public getNavbarHeight() {
    return this.navbarHeight;
  }

  public getFooterHeight() {
    return this.footerHeight;
  }

  public toggleMenu() {
    if (this.sidenavOpened) {
      this.sidenavOpened = false;
    } else {
      this.sidenavOpened = true;
    }
  }

  public sidenavLockedReceiver() {
    if (!this.sidenavMobile) {
      this.sidenavLocked = !this.sidenavLocked;
      if (!this.sidenavLocked) {
        this.sidenavOpened = false;
      } else {
        this.sidenavOpened = true;
      }
    }
  }
  public sidenavOpenedReceiver() {
      this.sidenavOpened = !this.sidenavOpened;
  }
}
